<template>
  <Modal class="text-center" type="modal-sm">
    <IconImportant height="50" class="danger mb-3" />
    <p class="font-weight-normal">You have unsaved changes on this page. If you continue, you will lose those changes.</p>
    <button class="btn btn-primary mb-2" @click="stay">Stay on this page</button><br>
    <button class="btn btn-link text-danger" @click="revert">Continue</button>
  </Modal>
</template>

<script>
import Modal from '@/components/Modal'

export default {
  components: {
    Modal
  },
  methods: {
    stay: function () {
      this.$emit('stay')
    },
    revert: function () {
      this.$emit('revert')
    }
  }
}
</script>
